// src/services/planesAccionService.js
import axios from 'axios';
import config from '../../../config'; // Asegúrate que config.baseUrl esté bien definido

const baseUrl = config.baseUrl;
const endpoint = '/api/planes-accion';
const API_URL = `${baseUrl}${endpoint}`;

const planesAccionService = {
  // Obtener todos los datos divididos por tipo_ejecucion
  getPlanesAccion: async () => {
    try {
      const response = await axios.get(API_URL);
      return response.data; // { tipo1: [...], tipo2: [...] }
    } catch (error) {
      console.error("Error obteniendo los datos:", error);
      throw error;
    }
  },

  // Actualizar propuesto y ejecucion de un registro específico
  updatePlanesAccion: async (oid, propuesto, ejecucion) => {
    try {
      const response = await axios.put(`${API_URL}/${oid}`, {
        propuesto,
        ejecucion
      });
      return response.data;
    } catch (error) {
      console.error(`Error actualizando el registro ${oid}:`, error);
      throw error;
    }
  }
};

export default planesAccionService;
